import { Formik } from "formik";
import "./../profile.css";
import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";
import { validateCancleOrder } from "../../../constant/validation";
import { getUser } from "../../../constant/utils";
import { useSelector } from "react-redux";
interface IMember {
  open: boolean;
  editData: any;
  handleClose: () => void;
  handleSubmit: (data: any) => void;
}
const CancelOrder = ({
  open,
  handleClose,
  handleSubmit,
  editData,
}: IMember) => {
  ReactModal.setAppElement("body");
  const USER: any = getUser();
  const [initialValue, setInitialValue] = useState<any>({
    BookingID: "",
    OrderName: "",
    Message: "",
    Reason: "",
  });
  const actionLoading:boolean = useSelector((state:any) => state.profile.actionLoading || false);
  useEffect(() => {
    setInitialValue({
      ...initialValue,
      BookingID: editData?.CrmData?.id,
    });
  }, [editData]);

  return (
    <ReactModal
      isOpen={open}
      /* style={customStyles} */
      onRequestClose={handleClose}
      className="my_acc_modal"
      overlayClassName="my_acc_overlay"
    >
      <div className="cross_button">
        <img
          src="/assets/img/my-profile/cross.png"
          alt=""
          className="cursor-pointer"
          onClick={handleClose}
        />
        <div className="acc_modal_content">
          <h6 className="pb-3">Cancel Order</h6>
          <div>
            <Formik
              initialValues={initialValue}
              enableReinitialize={true}
              validationSchema={validateCancleOrder}
              onSubmit={(val: any) => {
                handleSubmit({
                  UserId: USER?.Id,
                  BookingId: editData?.id,
                  CrmBookingId:editData?.CrmData?.id,
                  CancelReason:
                    val?.Reason === "Other" ? val?.Mesaage : val?.Reason,
                });
              }}
              render={({
                values,
                handleChange,
                errors,
                touched,
                handleBlur,
                handleSubmit,
              }) => (
                <form onSubmit={handleSubmit}>
                  <div className="row align-items-start">
                    {/* <div className="col-sm-6">
                      <div className="form-group">
                        <label className="profileLabel">Order Details</label>
                        <input
                          type="text"
                          name="OrderName"
                          className="form-control profileInp"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values?.OrderName}
                          disabled={true}
                        />
                        {touched?.OrderName && errors?.OrderName && (
                          <span className="error_message">
                            {errors?.OrderName}
                          </span>
                        )}
                      </div>
                    </div> */}
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label className="profileLabel">Booking ID</label>
                        <input
                          type="text"
                          name="BookingID"
                          className="form-control profileInp"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values?.BookingID}
                          disabled={true}
                        />
                        {touched?.BookingID && errors?.BookingID && (
                          <span className="error_message">
                            {errors?.BookingID}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-group">
                        <select
                          name="Reason"
                          className="form-control profileInp"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values?.Reason}
                        >
                          <option value="">
                            {" "}
                            Select reason for cancellation
                          </option>
                          <option value="Wrong address selected"> Wrong address selected</option>
                          <option value="Changed my mind">Changed my mind</option>
                          <option value="Booked by mistake">Booked by mistake</option>
                          <option value="Want to reschedule my booking">
                            Want to reschedule my booking
                          </option>
                          <option value="Other">Other</option>
                        </select>
                        {touched?.Reason && errors?.Reason && (
                          <span className="error_message">
                            {errors?.Reason}
                          </span>
                        )}
                      </div>
                    </div>
                    {values?.Reason === "Other" && (
                      <div className="col-12">
                        <div className="form-group">
                          <label className="profileLabel">
                            Could You Tell Us A Reason For Canceling?*
                          </label>
                          <textarea
                            name="Message"
                            className="form-control profileInp"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values?.Message}
                            rows={3}
                          />
                          {touched?.Message && errors?.Message && (
                            <span className="error_message">
                              {errors?.Message}
                            </span>
                          )}
                        </div>
                      </div>
                    )}
                    <div className="col-12 text-center">
                      <button
                        type="submit"
                        className="book--hexagon active sm_form"
                        disabled={actionLoading}
                      >
                        <span>
                          Cancel Order
                          <i
                            className="fa fa-long-arrow-right ml-20"
                            aria-hidden="true"
                          ></i>
                        </span>
                      </button>
                    </div>
                  </div>
                </form>
              )}
            />
          </div>
        </div>
      </div>
    </ReactModal>
  );
};

export default CancelOrder;
